import { render } from "./shield.vue?vue&type=template&id=55f7be1b"
const script = {}
script.render = render

export default script